<button class="toggle-icon-button" [attr.data-variant]="variant" [attr.data-size]="size" [attr.data-position]="position"
  [attr.data-pressed]="pressed" [attr.data-disabled]="disabled" [disabled]="disabled"
  [attr.aria-label]="computedAriaLabel" [attr.aria-pressed]="computedAriaPressed" (click)="onButtonClick($event)"
  type="button">

  <!-- Phosphor Icon -->
  <span class="icon" aria-hidden="true">
    <umss-icon [name]="defaultIconName" [size]="iconSize"></umss-icon>
  </span>

</button>